import axios from 'axios';
import { UNKNOWN_ERROR } from '../../../../helpers/Constants';

const fetchGlobalInvoicePdfService = async id => {
  try {
    const data = await axios.get(`/api/orderinvoice/${id}/marketinvoicerpdf`);
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.message ?? UNKNOWN_ERROR);
  }
};

// eslint-disable-next-line import/prefer-default-export
export { fetchGlobalInvoicePdfService };
